module.exports = __webpack_public_path__ + "img/Microsoft.17008c5.svg";